import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShareModule } from 'src/app/share-module';
import { ComponentsModule } from 'src/app/components/components-module';
import { BookmarksComponent } from './bookmarks/bookmarks.component';
import { MyListComponent } from './my-list/my-list.component';
import { RatesListComponent } from './rates-list/rates-list.component';
import { RentalHistoryListComponent } from './rental-history-list/rental-history-list.component';
import { ViewingListComponent } from './viewing-list/viewing-list.component';

@NgModule({
    imports: [
        CommonModule,
        ShareModule,
        ComponentsModule
    ],
    declarations: [
        BookmarksComponent,
        MyListComponent,
        RatesListComponent,
        RentalHistoryListComponent,
        ViewingListComponent
    ]
})

export class ListsModule { }